import { observer } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';
import { Button, Portal } from '@gem/ui-kit';

import usePresenter from './presenter';
import styles from './styles.m.scss';

const RequestPermission = () => {
  const presenter = usePresenter();
  const { t } = useTranslation();

  if (!presenter.isShowDialog) {
    return null;
  }

  return (
    <Portal>
      <div className={styles.popup}>
        <div className={styles.text}>{t('notifications_required_alert')}</div>
        <div className={styles.actionPanel}>
          <Button
            onClick={presenter.onClose}
            className={styles.button}
            theme="primary"
          >
            {t('ok')}
          </Button>
        </div>
      </div>
    </Portal>
  );
};

export default observer(RequestPermission);
